import { Injectable } from '@angular/core';
import { LanguagePreferenceService } from './language-preference.service';
import { Country, publicCountries } from '@shared/models/countries.model';

@Injectable({
  providedIn: 'root',
})
export class GetPhoneCodeService {
  constructor(private languagePreferenceService: LanguagePreferenceService) {}

  checkPhoneCountries() {
    const countryCode = this.languagePreferenceService.getLanguagePreference().country_code ?? 'US';
    const countries: Country[] = Object.values(publicCountries);
    const phoneCountries = countries.find((item) => item.id === countryCode)!;
    return phoneCountries;
  }
}
